module.exports = __webpack_public_path__ + "img/rush-logo-bk12012021.cfd5899e.png";